export default "__VITE_ASSET__ad0e4574__"